export default "__VITE_ASSET__V5$r2K$7__"